<template>
    <span v-if="show" class="button-loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </span>
</template>

<script>
export default {
    props: {
        'show': {
            type: Boolean,
            default: () => { return false; }
        },
    },
}
</script>
